/**
 * Loads the npm-bundled translations for a locale (the CDN fallback path).
 */
export const loadBundledTranslations = async locale => {
  const packageResources = await import(`@wix/premium-purchase-plan-translations/src/assets/locale/messages_${locale}.json`);
  return {
    ...packageResources
  };
};
//# sourceMappingURL=loadBundledTranslations.js.map